import * as React from "react";
import styled from "styled-components";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

export function NavigationItem({
  icon,
  label,
  isSelected,
  tabIndex,
  onClick,
  isCollapsed,
  hasSubmenu,
  submenuOpen,
  isLocked,
  showProBadge,
}) {
  return (
    <NavItemWrapper
      isSelected={isSelected}
      role="menuitem"
      tabIndex={tabIndex}
      onClick={onClick} // Action de l'élément
      aria-selected={isSelected}
      isCollapsed={isCollapsed}
      isLocked={isLocked}
    >
      <NavIconWrapper>{icon}</NavIconWrapper> {/* Afficher l'icône */}
      {!isCollapsed && (
        <>
          <NavLabel>{label}</NavLabel>
          {showProBadge ? <ProBadge aria-label="PRO">PRO</ProBadge> : null}
          {hasSubmenu && (
            <ExpandIcon>
              {submenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ExpandIcon>
          )}
        </>
      )}
    </NavItemWrapper>
  );
}

const NavItemWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: "8px";
  background-color: ${(props) => (props.isSelected ? "rgba(0, 0, 0, 0.04)" : "inherit")};
  cursor: pointer;
  transition: padding 0.3s ease-in-out;
  padding: ${(props) => (props.isCollapsed ? "12px 8px" : "8px 38px")};
  gap: ${(props) => (props.isCollapsed ? "0" : "24px")};
  justify-content: ${(props) => (props.isCollapsed ? "center" : "flex-start")};
  align-items: center;
  opacity: ${(props) => (props.isLocked ? 0.55 : 1)};

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const NavIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;

  & > svg {
    width: 100%;
    height: 100%;
    color: inherit; /* Couleur de l'icône en fonction de l'état (sélectionné ou non) */
  }
`;

const NavLabel = styled.span`
  flex-grow: 1;
  width: 127px;
`;

const ProBadge = styled.span`
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.6px;
  padding: 2px 6px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.04);
`;

const ExpandIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;

  & > svg {
    width: 100%;
    height: 100%;
    color: inherit;
  }
`;
